export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Відкрити спір"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скасувати"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Відправити"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["До вас приєднається модератор для допомоги. Будь ласка, оберіть причину та додайте докази."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Відправити модератору"])}
}